import { action } from 'mobx';
import { TrackingService } from 'common/data';
import { BaseStore } from 'core/stores';
import _ from 'lodash';

class TrackingStore extends BaseStore {
	constructor(rootStore) {
		super(new TrackingService(rootStore.app.baasic.apiClient));
	}

	@action
	track = async body => {
		const response = await this.service.track(body);
		this.response = response.data;
	};
}

export default TrackingStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/TrackingStore.js